export default {
    searchText: 'Search by Employee name, ID',
    search: 'Search',
    create: 'Create New Member',
    employeeId: 'Employee ID',
    employeeName: 'Employee Name',
    username: 'Username',
    phoneNumber: 'Phone number',
    action: 'Action',
    congratulation: 'Congratulation',
    userIsDeleted: 'User is deleted',
    deleteUser: 'Delete User',
    wantToDelete: 'Are you sure you want to delete'
}
